import React from "react";
import {
  GraphicEqIcon,
  NoteStackIcon,
  PodcastIcon,
  TripIcon,
} from "../assets/icons";
import { QuestionMark, Work } from "@mui/icons-material";

/**
 * Component that renders the appropriate icon based on contract type
 */
export const ContractTypeIcon: React.FC<{ type: string }> = ({ type }) => {
  switch (type) {
    case "management":
      return <TripIcon className="size-4" />;
    case "recording":
      return <GraphicEqIcon className="size-4" />;
    case "producer":
      return <NoteStackIcon className="size-4" />;
    case "publishing":
      return <PodcastIcon className="size-4" />;
    case "services":
      return <Work className="size-4" />;
    case "tbd":
      return <QuestionMark className="size-4" />;
    default:
      return <QuestionMark className="size-4" />
  }
};